var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightPagi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1233 8.46728L7.94325 5.28728C7.87353 5.21698 7.79058 5.16119 7.69918 5.12311C7.60779 5.08503 7.50976 5.06543 7.41075 5.06543C7.31174 5.06543 7.21371 5.08503 7.12232 5.12311C7.03092 5.16119 6.94797 5.21698 6.87825 5.28728C6.73856 5.4278 6.66016 5.61789 6.66016 5.81603C6.66016 6.01417 6.73856 6.20426 6.87825 6.34478L9.53325 8.99978L6.87825 11.6548C6.73856 11.7953 6.66016 11.9854 6.66016 12.1835C6.66016 12.3817 6.73856 12.5718 6.87825 12.7123C6.94833 12.7818 7.03144 12.8368 7.12282 12.8741C7.2142 12.9114 7.31205 12.9303 7.41075 12.9298C7.50946 12.9303 7.6073 12.9114 7.69868 12.8741C7.79006 12.8368 7.87317 12.7818 7.94325 12.7123L11.1233 9.53228C11.1935 9.46256 11.2493 9.3796 11.2874 9.28821C11.3255 9.19682 11.3451 9.09879 11.3451 8.99978C11.3451 8.90077 11.3255 8.80274 11.2874 8.71135C11.2493 8.61995 11.1935 8.537 11.1233 8.46728Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPagi);
export default __webpack_public_path__ + "static/media/right_pagi.3106c3ead9d2c37d24b831db8b934ad2.svg";
export { ForwardRef as ReactComponent };